module.exports = __webpack_public_path__ + "static/company_address-be39af13be421678a50dca1c2ce6b9ea.png";